import React, { useState } from "react";
import {
  FaCar,
  FaUserTie,
  FaHandshake,
  FaHeadset,
  FaPhoneAlt,
  FaEnvelope,
  FaWhatsapp,
  FaMapMarkerAlt,
} from "react-icons/fa";

const Career = () => {
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
    position: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const text = `
✈️ Mumbai Airport Cab Service - Career Application

👤 Name: ${formData.name}
📱 Mobile: ${formData.mobile}
📧 Email: ${formData.email}
💼 Position: ${formData.position}

📝 Message:
${formData.message}
`;

    const whatsappURL = `https://wa.me/919545731161?text=${encodeURIComponent(text)}`;

    window.open(whatsappURL, "_blank");
  };

  return (
    <div className="career-page">

      {/* HERO */}
<div
        className="breadcumb-wrapper"
        style={{
          backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="container z-index-common">
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">Career</h1>
          </div>
        </div>
      </div>



      <section className="career-section container">

        {/* GRID */}
        <div className="row g-4">

          <div className="col-md-6">

            <div className="career-card">
              <FaHandshake className="icon" />
              <h3 className="text-white">Business Partner</h3>
              <p>Start your own airport cab business with guaranteed booking support.</p>
            </div>

            <div className="career-card">
              <FaCar className="icon" />
              <h3 className="text-white">Driver Partner</h3>
              <p>Earn steady income by providing airport pickup & drop services.</p>
            </div>

            <div className="career-card">
              <FaUserTie className="icon" />
              <h3 className="text-white">Travel Consultant</h3>
              <p>Assist customers with Mumbai airport transfers and bookings.</p>
            </div>

            <div className="career-card">
              <FaHeadset className="icon" />
              <h3 className="text-white">Customer Support</h3>
              <p>Handle booking queries and ensure smooth travel experience.</p>
            </div>

          </div>

          {/* FORM */}
          <div className="col-md-6">

            <div className="career-form-box">
              <h2>Apply Now</h2>

              <form onSubmit={handleSubmit}>

                <input
                  type="text"
                  name="name"
                  placeholder="Full Name"
                  onChange={handleChange}
                  required
                />

                <input
                  type="tel"
                  name="mobile"
                  placeholder="Mobile Number"
                  onChange={handleChange}
                  required
                />

                <input
                  type="email"
                  name="email"
                  placeholder="Email Address"
                  onChange={handleChange}
                  required
                />

                <select name="position" onChange={handleChange} required>
                  <option value="">Select Position</option>
                  <option>Driver Partner</option>
                  <option>Travel Consultant</option>
                  <option>Business Partner</option>
                  <option>Customer Support</option>
                </select>

                <textarea
                  name="message"
                  rows="4"
                  placeholder="Tell us about yourself"
                  onChange={handleChange}
                />

                <button type="submit">
                  <FaWhatsapp /> Submit via WhatsApp
                </button>

              </form>
            </div>
          </div>
        </div>

        {/* CONTACT */}
        <div className="row mt-5">

          <div className="col-md-6">
            <div className="contact-box">
              <FaPhoneAlt />
              <a href="tel:+919545731161">+91 9545731161</a>
            </div>

            {/* <div className="contact-box">
              <FaWhatsapp />
              <a href="https://wa.me/919545731161" target="_blank" rel="noreferrer">
                WhatsApp Chat
              </a>
            </div> */}
            <div className="contact-box">
  <FaWhatsapp />
  <a
    href="https://wa.me/919545731161"
    target="_blank"
    rel="noreferrer"
  >
    WhatsApp Chat
    <br />
    +91 9545731161
  </a>
</div>

            <div className="contact-box">
              <FaEnvelope />
              <a href="mailto:booking@mumbaiairportcabservice.com">
                booking@mumbaiairportcabs.com
              </a>
            </div>
          </div>

          <div className="col-md-6">
            <div className="contact-address">
              <FaMapMarkerAlt />
              <p>
               <h6 className="fw-bold darkcoolorr"> Mumbai Airport Cab </h6>
                SAWANT SADAN 05 Ramachandra cold drinks House,
                  Near SBI Bank Nehru Road Opp Noble Medical,
                  Vile Parle East Mumbai-400057
              </p>
            </div>
          </div>

        </div>

      </section>
    </div>
  );
};

export default Career;